import I18n from './i18n';

if (window.IMAGINARY === undefined) {
  window.IMAGINARY = {};
}
window.IMAGINARY.i18n = new I18n();
